// extracted by mini-css-extract-plugin
export default {"host":"DailyAttendanceCheckInCheckOutPdf_host__uOAZ-"};